import { useContext, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, Snackbar, Typography } from "@mui/material";
import { HOME_PATH } from "../../../constants";
import { GlobalContext } from "../../common/Context";
import { NavLink, useHistory } from "react-router-dom";
import ErrorGraphic from "./ErrorGraphic";
import { useTranslation } from "react-i18next";
import { Close, ExpandMore } from "@mui/icons-material";

const ErrorPage = ({ pageNotFound, error }) => {
  const { t } = useTranslation("Navigation");
  const { mobileView, tabletView, setNotFound, optionState, currentUser, userState, setOptionState } = useContext(GlobalContext);

  const history = useHistory();

  const [copyOpen, setCopyOpen] = useState(false);

  setNotFound(pageNotFound);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "80vh",
    justifyContent: "center",
    maxWidth: "55rem",
    px: 6,
    m: "0 auto",
  };
  const buttonStyle = {
    width: "100%",
    maxWidth: mobileView ? "100%" : "20rem",
  };
  const navStyle = {
    marginBottom: "16px",
  };
  const leftStyle = {
    display: "flex",
    flexDirection: "column",
    mr: !mobileView && (tabletView ? 3 : 6),
    alignItems: mobileView && "center",
    width: "20rem",
  };
  const descTextStyle = {
    mb: mobileView ? 2 : 4,
  };
  const mainTextStyle = {
    fontSize: mobileView ? "2.5rem" : tabletView ? "3.5rem" : "5.5rem",
    mb: 1,
  };
  const titleTextStyle = {
    mb: 1,
  };
  const boxStyle = {
    display: "flex",
    flexDirection: mobileView ? "column-reverse" : "row",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const wrongVariant = mobileView ? "h3" : "h2";
  const errorTextStyle = {
    mb: 1,
    wordBreak: "break-word",
    fontFamily: "monospace",
  };

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(
      `${error.toString()}
optionState: ${JSON.stringify(optionState)}
history: ${JSON.stringify(history)}
currentUser: ${JSON.stringify(currentUser)}
userState: ${JSON.stringify(userState)}`,
    );
    setCopyOpen(true);
  };

  const handleCopyClose = () => setCopyOpen(false);

  const handleBackClick = () => setOptionState({ nav: "dashboard" });

  const copyCloseButton = (
    <IconButton size="small" aria-label="close" onClick={handleCopyClose}>
      <Close fontSize="small" sx={{ color: "#fff" }} />
    </IconButton>
  );

  return (
    <>
      <Box sx={containerStyle}>
        <Box sx={boxStyle}>
          <Box sx={leftStyle}>
            <Typography color="#C31CF3" variant="h1" sx={mainTextStyle}>
              {t("oops")}
            </Typography>
            <Typography color="primary" variant={wrongVariant} sx={titleTextStyle}>
              {pageNotFound ? t("notFound") : t("somethingWentWrong")}
            </Typography>
            <Typography color="primary" variant="body1" sx={descTextStyle}>
              {t("returnToDashboard")}
            </Typography>
            {history.location.pathname !== HOME_PATH ? (
              <NavLink to={HOME_PATH} style={() => ({ ...buttonStyle, ...navStyle })}>
                <Button variant="contained" color="info" sx={buttonStyle}>
                  <Typography color="#fff" variant="h4" textTransform="none">
                    {t("backToDashboard")}
                  </Typography>
                </Button>
              </NavLink>
            ) : (
              <Button variant="contained" color="info" sx={buttonStyle} onClick={handleBackClick}>
                <Typography color="#fff" variant="h4" textTransform="none">
                  {t("backToDashboard")}
                </Typography>
              </Button>
            )}
          </Box>
          <ErrorGraphic />
        </Box>
        {error && (
          <>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{t("errorDetails")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={errorTextStyle}>{error.toString()}</Typography>
                <Typography sx={errorTextStyle}>optionState: {JSON.stringify(optionState)}</Typography>
                <Typography sx={errorTextStyle}>history: {JSON.stringify(history)}</Typography>
                <Typography sx={errorTextStyle}>currentUser: {JSON.stringify(currentUser)}</Typography>
                <Typography sx={errorTextStyle}>userState: {JSON.stringify(userState)}</Typography>
                <Button onClick={handleCopyClick}>
                  <Typography color="primary" variant="h4" textTransform="none">
                    {t("copyError")}
                  </Typography>
                </Button>
              </AccordionDetails>
            </Accordion>
          </>
        )}
      </Box>
      <Snackbar open={copyOpen} autoHideDuration={6000} onClose={handleCopyClose} message={t("copiedError")} action={copyCloseButton} />
    </>
  );
};

export default ErrorPage;
